import api from '../api'
import {
  SIGNUP,
  LOGIN,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  LOGOUT,
  GET_PROFILE,
  EDIT_PROFILE,
  DELETE_PROFILE
} from '../constants/userConstants'
import { ERROR, LOADING } from '../constants/globalConstants'

export const signup = (name, email, password) => async dispatch => {
  try {
    dispatch({
      type: LOADING
    })

    const { data } = await api.post('/auth/signup', { name, email, password })

    localStorage.setItem('eclsusr', JSON.stringify(data))
    dispatch({
      type: SIGNUP,
      payload: data
    })
  } catch (error) {
    dispatch({
      type: ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const login = (email, password) => async dispatch => {
  try {
    dispatch({
      type: LOADING
    })

    const { data } = await api.post('/auth/login', { email, password })

    localStorage.setItem('eclsusr', JSON.stringify(data))
    dispatch({
      type: LOGIN,
      payload: data
    })
  } catch (error) {
    dispatch({
      type: ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const forgotPassword = (email) => async dispatch => {
  try {
    dispatch({
      type: LOADING
    })

    const { data } = await api.post('/auth/forgot-password', { email })

    dispatch({
      type: FORGOT_PASSWORD,
      payload: data.msg
    })
  } catch (error) {
    dispatch({
      type: ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const resetPassword = (token, password) => async dispatch => {
  try {
    dispatch({
      type: LOADING
    })

    const { data } = await api.post(`/auth/reset-password/${token}`, { password })

    dispatch({
      type: RESET_PASSWORD,
      payload: data.msg
    })
  } catch (error) {
    dispatch({
      type: ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const logout = () => async dispatch => {
  localStorage.removeItem('eclsusr')
  dispatch({
    type: LOGOUT
  })
}

export const getProfile = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: LOADING
    })

    const { userState: { userInfo: { token } } } = getState()
    const config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }

    const { data } = await api.get('/auth/profile', config)
    dispatch({
      type: GET_PROFILE,
      payload: data
    })
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message
    if (message === 'Not authorized, token failed') {
      dispatch(logout())
    }
    alert('Something went wrong')
  }
}

export const editProfile = (name, newPassword, currentPassword) => async (dispatch, getState) => {
  try {
    dispatch({
      type: LOADING
    })

    const { userState: { userInfo: { token } } } = getState()
    const config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }

    const { data } = await api.put('/auth/profile', { name, newPassword, currentPassword }, config)
    dispatch({
      type: EDIT_PROFILE,
      payload: { data, token }
    })
  } catch (error) {
    dispatch({
      type: ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}

export const deleteProfile = (password) => async (dispatch, getState) => {
  try {
    dispatch({
      type: LOADING
    })

    const { userState: { userInfo: { token } } } = getState()
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      data: JSON.stringify({ password })
    }

    await api.delete('http://localhost:5000/auth/profile', config)

    localStorage.removeItem('eclsusr')
    dispatch({
      type: DELETE_PROFILE,
    })
  } catch (error) {
    dispatch({
      type: ERROR,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    })
  }
}